import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import * as FiIcons from "react-icons/fi";
import ClientReportTable from "./ClientReportTable";

export default function ClientReportViewer({ report, loading, error, currency, onPreview, onExport }) {
  return (
    <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="flex flex-col gap-3 border-b border-slate-100 p-5 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-widest text-violet-700">Generated report</p>
          <h2 className="mt-1 text-lg font-black text-slate-900">{report?.title || "Report preview"}</h2>
          {report?.period && <p className="mt-1 text-xs text-slate-500">{report.period}</p>}
        </div>
        {report && (
          <div className="flex gap-2">
            <button type="button" onClick={onPreview} className="rounded-xl border border-slate-200 px-3 py-2 text-xs font-bold text-slate-700 hover:bg-slate-50">
              Preview
            </button>
            <button type="button" onClick={onExport} className="inline-flex items-center gap-2 rounded-xl bg-slate-900 px-3 py-2 text-xs font-bold text-white hover:bg-slate-800">
              <SafeIcon icon={FiIcons.FiDownload} /> Export CSV
            </button>
          </div>
        )}
      </div>
      <div className="p-4 md:p-6">
        {loading && (
          <div className="flex items-center justify-center gap-3 py-12 text-sm text-slate-500">
            <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" /> Generating organization report…
          </div>
        )}
        {!loading && error && (
          <div role="alert" className="rounded-xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800">
            <p className="font-bold">Report unavailable</p>
            <p className="mt-1">{error}</p>
          </div>
        )}
        {!loading && report?.supported === false && (
          <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
            <p className="font-bold">This report is not available yet</p>
            <p className="mt-1">{report.reason}</p>
          </div>
        )}
        {!loading && report && report.supported !== false && (
          <>
            {report.warnings?.map((warning) => (
              <p key={warning} className="mb-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-800">
                {warning}
              </p>
            ))}
            <ClientReportTable
              columns={report.columns}
              rows={report.rows}
              currency={currency}
              emptyLabel={report.emptyLabel}
            />
            {report.metadata && (
              <p className="mt-4 text-right text-[10px] text-slate-400">
                {report.metadata}
              </p>
            )}
          </>
        )}
        {!loading && !report && !error && (
          <p className="py-10 text-center text-sm text-slate-500">
            Choose a report and generate it to see your organization's financial data.
          </p>
        )}
      </div>
    </section>
  );
}